var map = {
	"./dm-sans-v15-latin-500.woff2": "./fonts/dm-sans-v15-latin-500.woff2",
	"./dm-sans-v15-latin-600.woff2": "./fonts/dm-sans-v15-latin-600.woff2",
	"./dm-sans-v15-latin-700.woff2": "./fonts/dm-sans-v15-latin-700.woff2",
	"./dm-sans-v15-latin-regular.woff2": "./fonts/dm-sans-v15-latin-regular.woff2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./fonts sync recursive ^\\.\\/.*$";